export function humanReadableFileSize(size: number): string {
  let i = -1;
  const sizes = ['kB', 'MB', 'GB', 'TB'];
  do {
    size = size / 1024;
    i++;
  } while (size > 1024 && i < 4);
  return Math.max(0.1, size).toFixed(1) + ' ' + sizes[i];
}
